import React, { useState, useEffect } from 'react'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useSelector, useDispatch } from "react-redux";
import Button from '@mui/material/Button';
import { Link, useLocation } from "react-router-dom";
import { AppliedJobViewAction } from "./../../Redux/action/AppliedJobsVendorAction";
import { TbExternalLink } from 'react-icons/tb';
import { MdOutlineBackup } from 'react-icons/md';
import { FaCircleInfo } from "react-icons/fa6";
import Pagination from '../Common/Pagination/Pagination';
import { fetchDesignationDetails } from '../../Redux/action/MasterSkillAction';
import Select from "react-select";
const AppliedJobsVendor = (props) => {
    const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(20);
    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(0);
    const userInfo = useSelector((state) => state?.AppliedJobsVendorReducer?.result?.content);
    const totalPages = useSelector((state) => state?.AppliedJobsVendorReducer?.result?.totalPages);
    const [selectedDesignation, setSelectedDesignation] = useState([]);
    const [designationSendapi, setDesignationSendAPI] = useState([]);
    const AllDesignationList = useSelector(
        (state) => state?.MasterTableDetails?.designation?.content
    );
    const handleDesignationChange = (selectedOptions) => {
        setSelectedDesignation(selectedOptions);
        const selectedValues = selectedOptions.map((option) => option.value);
        setDesignationSendAPI(selectedValues);
    };
    let dispatch = useDispatch();
    const location = useLocation();
    const queryParams = new URLSearchParams(location?.search);
    const vId = queryParams?.get('vendorId');
    const { userResult } = useSelector((state) => state.Auth);
    const id = vId ? vId : userResult?.vendorid;
    const posted = props.posted

    const content = {
        id,
        posted,
        pageNumber,
        search,
        designationSendapi
    }

    useEffect(() => {
        dispatch(AppliedJobViewAction(content));
    }, [pageNumber, selectedDesignation]);

    const handleClick = (e) => {
        setcurrentPage(Number(e.target.id));
    };

    const pages = [];
    for (let i = 1; i <= Math.ceil(userInfo?.length / itemsPerPage); i++) {
        pages.push(i);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = userInfo?.slice(indexOfFirstItem, indexOfLastItem);
    const newData = userInfo;
    const renderPageNumbers = pages.map((number) => {
        if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
            return (
                <li
                    key={number}
                    id={number}
                    onClick={handleClick}
                    className={currentPage === number ? "active" : null}
                >
                    {number}
                </li>
            );
        } else {
            return null;
        }
    });

    const handleNextbtn = () => {
        setcurrentPage(currentPage + 1);
        if (currentPage + 1 > maxPageNumberLimit) {
            setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
        }
    };

    const handlePrevbtn = () => {
        setcurrentPage(currentPage - 1);
        if ((currentPage - 1) % pageNumberLimit === 0) {
            setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
            setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
        }
    };

    function convertTimestampToDate(timestamp) {
        const date = new Date(timestamp);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }

    let pageIncrementBtn = null;
    if (pages.length > maxPageNumberLimit) {
        pageIncrementBtn = <li onClick={handleNextbtn}> &hellip; </li>;
    }

    let pageDecrementBtn = null;
    if (minPageNumberLimit >= 1) {
        pageDecrementBtn = <li onClick={handlePrevbtn}> &hellip; </li>;
    }

    const handlePageChange = (page) => {
        setPageNumber(page);
        // You can also fetch data for the new page here or update your component state accordingly
    };
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        dispatch(fetchDesignationDetails());
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const designationOptions = AllDesignationList?.map((item) => ({
        value: item?.designation,
        label: item?.designation,
    }));
    return (
        <div>
            <div style={{ padding: "10px 20px", borderBottom: "1px solid #d2d7d7" }}>
                <div className={width > 768 ? "form-outline" : ""}>
                    {/* <input
                        className="form-control"
                        type="search"
                        placeholder="Search by Designation"
                        name="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    ></input> */}
                    <div style={{ minWidth: '200px' }}>
                        <Select
                            options={designationOptions}
                            isMulti
                            onChange={handleDesignationChange}
                            placeholder="Select Designation"
                            value={selectedDesignation}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#286a94" : "#ccc",
                                    boxShadow: state.isFocused ? "0 0 0 1px #286a94" : "none",
                                    "&:hover": { borderColor: "#286a94" },
                                    minHeight: "25px",
                                    fontSize: "11px", // affects input text
                                }),
                                option: (base, state) => ({
                                    ...base,
                                    fontSize: "10px",   // dropdown options font size
                                    padding: "6px 8px",
                                    backgroundColor: state.isSelected
                                        ? "#286a94"
                                        : state.isFocused
                                            ? "#e6f2fa"
                                            : "white",
                                    color: state.isSelected ? "white" : "#333",
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: "#e6f2fa",
                                    borderRadius: "8px",
                                    padding: "0px 0px",
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    fontSize: "11px",   // selected tag label font size
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontSize: "11px",   // for single select case
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    color: "#777",
                                    fontSize: "11px",
                                }),
                            }}
                        />
                    </div>
                </div>

            </div>
            <div className="">
                <div className="card-header common_table_header">
                    Applied Jobs
                </div>
                <div className="card-body table-responsive">
                    <table className="table-data" style={{ fontSize: '14px', overflowX: 'auto', minWidth: location.pathname.includes('admin') ? '65rem' : "" }}>
                        <thead>
                            <tr>
                                <th className='fw_500' scope="col">Job Id</th>
                                <th className='fw_500' scope="col">Team Member ID</th>
                                <th className='fw_500' scope="col">Name</th>
                                <th className='fw_500' scope="col">Designation</th>
                                {/* <th className='fw_500' scope="col">Key Skills</th> */}
                                <th className='fw_500' scope="col">Status</th>
                                <th className='fw_500' scope="col">Applied Date</th>
                                <th className='fw_500' scope="col">Job Details</th>
                                {/* <th className='fw_500' scope="col">Post</th> */}
                                {/* <th className='fw_500' scope="col">Action</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems && currentItems.map((item, i) => {
                                return (
                                    <>
                                        <tr key={i}>
                                            <td>{item.jobUuid}</td>
                                            <td>{item.candidateEmpId}</td>
                                            <td>{item.candidateName}</td>
                                            <td>{item.jobTitle}</td>
                                            {/* <td>{item.requiredSkills}</td> */}
                                            <td>
                                                <div style={{ display: "flex" }}>  <div style={{ minWidth: "70%" }} className={`text-start mb-0 ${(item.jobAcceptanceStatus === 'REJECTED' || item.jobAcceptanceStatus === 'NOT_SHORTLISTED') ? 'red_status' : (item.jobAcceptanceStatus === "PENDING") ? 'yellow_status' : 'green_status'}`}>
                                                    {item.jobAcceptanceStatus === 'REJECTED' ? 'Rejected' : item.jobAcceptanceStatus === 'NOT_SHORTLISTED' ? 'Not ShortListed' : item.jobAcceptanceStatus === 'PENDING' ? 'Pending' : 'Scheduled'} {item.jobAcceptanceStatus === 'REJECTED' &&

                                                        <div className="arc_tooltip_applied" data-tooltip={item?.declinedReason}>
                                                            {/* <FaCircleInfo size={20} /> */}
                                                        </div>
                                                    }
                                                </div> </div>
                                            </td>
                                            <td>{convertTimestampToDate(item.createdAt)}</td>
                                            <td><Link to={location.pathname.includes('/admin/posted_jobs')
                                                ? `/admin/view/job-details?jobId=${item.jobId}`
                                                : location.pathname.includes('/admin/job/vendor_jobs')
                                                    ? `/admin/job/viewJob?jobId=${item.jobId}` : `/job-details/${item.jobId}`}>
                                                <TbExternalLink size={24} color='#286a94' />
                                            </Link></td>
                                            {/* <td>
                                            <MdOutlineBackup size={24} color='#286a94' className='pointer' />
                                        </td> */}
                                            {/* <td style={{ color: 'red', cursor: "pointer" }}><DeleteOutlineIcon /></td> */}
                                        </tr>
                                    </>
                                )
                            })}
                        </tbody>
                    </table>
                    {currentItems?.length === 0 && (
                        <div className="text-center mt-5">
                            <h5>No Data Found</h5>
                        </div>
                    )}
                </div>
            </div>
            {/* {userInfo.length >= 5 ? (
                <div className="mt-4">
                    <ul className="pageNumbers">
                        <li>
                            <button
                                onClick={handlePrevbtn}
                                disabled={currentPage === pages[0] ? true : false}
                            >
                                Prev
                            </button>
                        </li>
                        {pageDecrementBtn}
                        {renderPageNumbers}
                        {pageIncrementBtn}
                        <li>
                            <button
                                onClick={handleNextbtn}
                                disabled={
                                    currentPage === pages[pages.length - 1] ? true : false
                                }
                            >
                                Next
                            </button>
                        </li>
                    </ul>
                </div>
            ) : (
                ""
            )} */}

            {userInfo?.length >= 1 ? (
                <Pagination totalPages={totalPages} currentPage={pageNumber} onPageChange={handlePageChange} />
            ) : (
                ""
            )}
        </div>
    )
}

export default AppliedJobsVendor